module.exports = __webpack_public_path__ + "static/media/omni-channel.d1c52915.png";